<template>
  <div class="cms-pdf-link-list">
    <ul class="u-reset cms-pdf-link-list__item-list">
      <li v-for="(item, itemIdx) in pdfLinkList" :key="itemIdx" class="cms-pdf-link-list__item">
        <a
          :href="item.pdfLinkUrl"
          class="u-reset file-link cms-pdf-link-list__link"
          rel="noopener noreferrer"
          target="_blank"
        >
          <div class="cms-pdf-link-list__item-icon">
            <responsive-img
              :width="40"
              alt=""
              class="cms-pdf-link-list__item-image"
              src="/images/cms_components/pdf_file_small@3x.png"
            />
            <span class="cms-pdf-link-list__item-text">
              {{ item.pdfLinkText }}
            </span>
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  import ResponsiveImg from '~/components/responsive-img/responsive-img'

  export default {
    components: { ResponsiveImg },
    props: {
      pdfLinkList: {
        type: Array,
        required: true,
      },
    },
  }
</script>

<style lang="scss" src="./_cms-pdf-link-list.scss" />
